//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalApplicationsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Applications' stat={count} />;
};

export default TotalApplicationsWidget;
